module.exports = __webpack_public_path__ + "static/img/companyLeft.32d7de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyLeft.png
// module id = PSDI
// module chunks = 2